/* global axios */
import ApiClient from './ApiClient';

class CustomDashboardsAPI extends ApiClient {
  constructor() {
    super('custom_dashboards', { accountScoped: true });
  }

  newCustomDashboard(payload) {
    const { title, description, settings, attachment } = payload;

    const formData = new FormData();
    formData.append('title', title);
    formData.append('description', description || '');
    formData.append('settings', JSON.stringify(settings));
    if (attachment) formData.append('attachment', attachment);

    return axios.post(this.url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  updateCustomDashboard(id, payload) {
    const { title, description, settings, attachment } = payload;

    const formData = new FormData();
    formData.append('title', title);
    formData.append('description', description || '');
    formData.append('settings', JSON.stringify(settings));
    if (attachment) formData.append('attachment', attachment);

    return axios.patch(`${this.url}/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export default new CustomDashboardsAPI();
